module.exports = __webpack_public_path__ + "static/media/port-yahtzoo.42e0205c.png";